module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/manage/vle/vle.component.html
// module id = ./src/app/Pages/manage/vle/vle.component.html
// module chunks = main